export default __webpack_public_path__ + "static/assets/a906f839fd40d72c6d450e4965226234.svg";